import React, { useMemo } from 'react';
import AppPageHeader from '../shell/AppPageHeader';
import ManagedUserDirectoryPanel from '../shared/ManagedUserDirectoryPanel';
import { createPlatformRootUsersAdapter } from '../../services/managedDirectoryUsersApi';

export default function AdminRootUsers() {
  const adapter = useMemo(() => createPlatformRootUsersAdapter(), []);
  const header = useMemo(
    () => (
      <AppPageHeader
        title="Platform Users"
        subtitle="Root administrators who manage client licenses and firm provisioning"
      />
    ),
    []
  );

  return (
    <ManagedUserDirectoryPanel
      preset="platform"
      adapter={adapter}
      canManage
      idPrefix="admin-platform"
      pageHeader={header}
    />
  );
}
